exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.daily-history-table[data-v-1e447bd2] {\n  padding: 1rem;\n}\n.avatar[data-v-1e447bd2] {\n  width: 42px;\n  height: 42px;\n  margin: 0;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.avatar img[data-v-1e447bd2] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.avatar.no-image[data-v-1e447bd2] {\n  background-color: #e5e7eb; /* gray bg when no image */\n}\n", ""]);

// exports
